/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Auth_Login_SubtitleInputs */

const cs_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Portál makléře ${i?.name}`)
};

const en_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} agent portal`)
};

/**
* | output |
* | --- |
* | "{name} agent portal" |
*
* @param {Auth_Login_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_subtitle = /** @type {((inputs: Auth_Login_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_subtitle(inputs)
	return cs_auth_login_subtitle(inputs)
});